import React from "react";
import styles from "../Work/Work.module.css";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import portfolioMVPC from "../../../../assets/Images/Portfolio/portfolioHero.webp";
import portfolioMVMobile from "../../../../assets/Images/Portfolio/portfolioHeroMobile.webp";
import TsundokuMVMobile from "../../../../assets/Images/Tsundoku/TsundokuHeroMobile.webp";
import TsundokuMVPC from "../../../../assets/Images/Tsundoku/TsundokuHero.webp";
import TsundokuAdminStudioMVPC from "../../../../assets/Images/TsundokuAdminStudio/TsundokuAdminStudioHomeImgPC.webp";
import TsundokuAdminStudioMobile from "../../../../assets/Images/TsundokuAdminStudio/TsundokuAdminStudioHomeImgMobile.webp";
import greenhubPC from "../../../../assets/Images/Greenhub/greenhubPCpng.webp";
import greenhubMobile from "../../../../assets/Images/Greenhub/greenhubMobile.webp";

const Work = () => {
  const screenUnder847px = useMediaQuery({ query: "(max-width: 847px)" });

  return (
    <div className={styles.entireWork}>
      <div className={styles.workContentContainer}>
        <h2 className={styles.workTitle}>Work</h2>
        <Link to="/Work-Greenhub" reloadDocument>
          <div className={styles.workContent}>
            <img
              src={screenUnder847px ? greenhubMobile : greenhubPC}
              alt="Thumbnail for the `About My First Website` Page Link"
              className={styles.workContentImage}
            />
            <h3 className={styles.workText1}>
              <span className={styles.workText1Title}>
                Greenhub{" "}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 15L6.93125 13.95L11.1312 9.75H2V8.25H11.1312L6.93125 4.05L8 3L14 9L8 15Z"
                    fill="#279070"
                  />
                </svg>
              </span>
            </h3>
            <p className={styles.workText2}>
              <span>
                A platform for medical cannabis patients and users to find the
                products they are looking for across large areas in one
                filterable, sortable, comprehensive menu.
              </span>
            </p>
            <div className={styles.workText3}>
              <p className={styles.workContentTags}>Next.js / TS</p>
              <p className={styles.workContentTags}>Python</p>
              <p className={styles.workContentTags}>PostgreSQL</p>
              <p className={styles.workContentTags}>ETL Pipelines</p>
              <p className={styles.workContentTags}>DevOPS</p>
            </div>
          </div>
        </Link>
        <Link to="/Work-TsundokuAdminStudio" reloadDocument>
          <div className={styles.workContent}>
            <img
              src={
                screenUnder847px
                  ? TsundokuAdminStudioMobile
                  : TsundokuAdminStudioMVPC
              }
              alt="Thumbnail for the `About My First Website` Page Link"
              className={styles.workContentImage}
            />
            <h3 className={styles.workText1}>
              <span className={styles.workText1Title}>
                Tsundoku Admin Studio{" "}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 15L6.93125 13.95L11.1312 9.75H2V8.25H11.1312L6.93125 4.05L8 3L14 9L8 15Z"
                    fill="#279070"
                  />
                </svg>
              </span>
            </h3>
            <p className={styles.workText2}>
              <span>
                A custom-built CMS using Sanity Studio to manage and preview
                blog content for Tsundoku. Structured like a database, but
                flexible, editor-friendly, and optimized for secure publishing
                workflows.
              </span>
            </p>
            <div className={styles.workText3}>
              <p className={styles.workContentTags}>Sanity.io</p>
              <p className={styles.workContentTags}>Headless CMS</p>
              <p className={styles.workContentTags}>GROQ</p>
              <p className={styles.workContentTags}>TypeScript</p>
            </div>
          </div>
        </Link>
        <Link to="/Work-Tsundoku" reloadDocument>
          <div className={styles.workContent}>
            <img
              src={screenUnder847px ? TsundokuMVMobile : TsundokuMVPC}
              alt="Thumbnail of the `About Tsundoku Page` Link"
              className={styles.workContentImage}
            />
            <h3 className={styles.workText1}>
              <span className={styles.workText1Title}>
                Tsundoku{" "}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 15L6.93125 13.95L11.1312 9.75H2V8.25H11.1312L6.93125 4.05L8 3L14 9L8 15Z"
                    fill="#279070"
                  />
                </svg>
              </span>
            </h3>
            <p className={styles.workText2}>
              <span>
                My partner and I wanted our own space to share articles on web
                development, design, and lifestyle — so I built this blog
                platform from scratch using her design.
              </span>
            </p>
            <div className={styles.workText3}>
              <p className={styles.workContentTags}>Next.js</p>
              <p className={styles.workContentTags}>Sanity.io</p>
              <p className={styles.workContentTags}>TypeScript</p>
              <p className={styles.workContentTags}>TailwindCSS</p>
            </div>
          </div>
        </Link>
        <Link to="/Work-Portfolio" reloadDocument>
          <div className={styles.workContent}>
            <img
              src={screenUnder847px ? portfolioMVMobile : portfolioMVPC}
              alt="Thumbnail of the `About Portfolio Page` Link"
              className={styles.workContentImage}
            />
            <h3 className={styles.workText1}>
              <span className={styles.workText1Title}>
                Portfolio{" "}
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 15L6.93125 13.95L11.1312 9.75H2V8.25H11.1312L6.93125 4.05L8 3L14 9L8 15Z"
                    fill="#279070"
                  />
                </svg>
              </span>
            </h3>
            <p className={styles.workText2}>
              <span>
                My Portfolio Site that you are currently viewing. If you want to
                know more about what I learned while making it, feel free to
                click here!
              </span>
            </p>
            <div className={styles.workText3}>
              <p className={styles.workContentTags}>React</p>
              <p className={styles.workContentTags}>Responsive</p>
              <p className={styles.workContentTags}>Accessible</p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Work;
